<div class="patron-graph-page">
  <div class="flex justify-between items-center patron-graph-page__header">
    <a href="/home/patrons"
      ><button class="btn btn-default btn-sm gap-x-1 flex items-center">
        <i class="fas fa-arrow-left"></i>Back
      </button></a
    >
  </div>
  <div class="patron-graph-page__body">
    <app-assessment-graph-data></app-assessment-graph-data>
    <div class="absolute flex justify-center items-center top-0 left-0 right-0 bottom-0 m-0" *ngIf="isLoading">
      <div class="loader__scrim"></div>
      <span class="spinner-border"></span>
    </div>
    <ng-container *ngIf="!isLoading">
      <app-graph-module-relation-graph
        *ngIf="hierarchicalData"
        [hierarchicalData]="hierarchicalData"
        [names]="hierarchicalData.name"
        (nodeClick)="onNodeClick($event)"
      ></app-graph-module-relation-graph>
      <app-patron-graph-side-panel
        [patron]="patron"
        [selectedApi]="selectedApi"
        [(mode)]="sidePanelMode"
        [@panelState]="sidePanelMode"
      ></app-patron-graph-side-panel
    ></ng-container>
  </div>
</div>
